var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SidebarContentWrapper',{staticClass:"mb-3"},[_c('div',{staticClass:"header-logo-container"},[_c('img',{staticClass:"header-logo",attrs:{"src":_vm.src,"alt":"Logo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }